import { render, staticRenderFns } from "./peaCheck.vue?vue&type=template&id=4b30aeb1&scoped=true"
import script from "./peaCheck.vue?vue&type=script&lang=js"
export * from "./peaCheck.vue?vue&type=script&lang=js"
import style0 from "./peaCheck.vue?vue&type=style&index=0&id=4b30aeb1&prod&lang=css"
import style1 from "./peaCheck.vue?vue&type=style&index=1&id=4b30aeb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30aeb1",
  null
  
)

export default component.exports